import {Component, DestroyRef, inject, OnDestroy, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardModels} from 'src/app/models/dashboard-models';
import {DashboardService} from 'src/app/services/dashboard.service';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';
import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {HelperService} from 'src/app/services/helper.service';
import {DeviceDetectionService} from '../../services/device-detection-service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
    resultsLength = 0;


    /* Zuletzt verwendte Objekte */
    isLoadingObjectsResults = true;
    dataSourceObjekte: MatTableDataSource<DashboardModels.DashboardObjekt>;
    displayedObjektColumns: string[] = [
        'objectNo',
        'typeDesc',
        'desc',
        'address',
        'zip',
        'town',
        'objekt',
    ];
    selectedObjectID: string = '';
    /* Zuletzt verwendte Adressen */
    isLoadingAddressesResults = true;
    dataSourceAdressen: MatTableDataSource<DashboardModels.DashboardAdresse>;
    displayedAdresseColumns: string[] = [
        'adressNo',
        'name',
        'vorname',
        'strasse',
        'plzOrt',
        'tel',
        'mobile',
        'eMail',
    ];
    selectedAdressID: string = '';
    // Panel-Header Grösse
    expandPanelHeaderExpandendHeight: string = '42px';
    expandPanelHeaderCollapsedHeight: string = '42px';
    /* Datenstatus */
    hasLastViewedObjects: number = 0; // 0: nein | 1: ja
    hasLastViewedAddresses: number = 0; // 0: nein | 1: ja
    snackBarIsOpen: number = 0; // 0: nein | 1: ja
    onlineStateChanged?: Subscription;
    private objektUrl: string;
    private adresseUrl: string;
    private destroyRef = inject(DestroyRef);

    constructor(
        private svcDashboard: DashboardService,
        public breakpointObserver: BreakpointObserver,
        private router: Router,
        private route: ActivatedRoute,
        private userAuthService: UserAuthenticationService,
        private helperService: HelperService,
        private deviceDetection: DeviceDetectionService,
    ) {
        this.helperService.setPageRefreshURL('/dashboard').then(() => {
            if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
                this.router.navigate(['']);
            }
        });

        this.dataSourceObjekte =
            new MatTableDataSource<DashboardModels.DashboardObjekt>();
        this.objektUrl = this.route.snapshot.queryParams.returnUrl || '/objekte';

        this.dataSourceAdressen = new MatTableDataSource<DashboardModels.DashboardAdresse>();
        this.adresseUrl = this.route.snapshot.queryParams.returnUrl || '/adressen';

        /*svcDashboard.registerDasbordIconsFunc(
          this.reloadDashbordBadgeIcons.bind(this)
        );*/
    }

    ngOnInit(): void {
        // BreakpointObserver for Dashboard
        if (this.deviceDetection.getDevice().device.type === 'mobile') {
            this.helperService.setPageRefreshURL('/dashboard-mobile').then(() => {
                this.router.navigate(['dashboard-mobile']);
            });
        }

        this.reloadDashboardObjekte();
        this.reloadDashboardAdressen();

        this.onlineStateChanged = this.helperService.getOnlineStateChanged().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: () => {
                this.reloadDashboardObjekte();
                this.reloadDashboardAdressen();
            }
        });
    }

    ngOnDestroy() {
    }

    highlight(row: any) {
        this.selectedObjectID = row.objectID;
        if (row.objectID) {
            this.router.navigate([this.objektUrl, this.selectedObjectID]);
        }
    }

    highlightAdr(row: any) {
        this.selectedAdressID = row.adressID;
        if (row.adressID) {
            this.router.navigate([this.adresseUrl, this.selectedAdressID]);
        }
    }


    private reloadDashboardObjekte() {
        // Die durch den Benutzer zuletzt geöffneten Objekte ermitteln
        this.svcDashboard.getDashboardObjekte().subscribe({
            next: (res) => {
                this.resultsLength = res.length;

                if (this.resultsLength > 0) {
                    this.hasLastViewedObjects = 1;
                } else {
                    this.hasLastViewedObjects = 0;
                }

                // Die nächste Code-Zeile muss so bleiben, wegen der Performance.
                this.dataSourceObjekte! = new MatTableDataSource<DashboardModels.DashboardObjekt>(res);
                this.isLoadingObjectsResults = false;
            },
        });
    }

    private reloadDashboardAdressen() {
        // Die durch den Benutzer zuletzt geöffneten Adressen ermitteln
        this.svcDashboard.getDashboardAdressen().subscribe({
            next: (res) => {
                this.resultsLength = res.length;

                if (this.resultsLength > 0) {
                    this.hasLastViewedAddresses = 1;
                } else {
                    this.hasLastViewedAddresses = 0;
                }

                // Die nächste Code-Zeile muss so bleiben, wegen der Performance.
                this.dataSourceAdressen! =
                    new MatTableDataSource<DashboardModels.DashboardAdresse>(res);
                this.isLoadingAddressesResults = false;
            },
        });
    }
}
